<template>
  <div>
  <div class="row g-3 mt-1">

    <!-- Info Banner -->
    <div class="col-md-8 col-lg-6 mx-auto">
      <div class="d-flex align-items-center justify-content-between px-3 py-2 rounded mb-3"
           style="background-color: #fffbea; border: 2px solid #ebba03; cursor: pointer;"
           @click="toggleInformation">
        <div class="d-flex align-items-center gap-2">
          <i class="fa fa-info-circle text-warning fs-5"></i>
          <span class="fw-semibold text-dark text-start">
            You can earn more free days or usage credit by using one of the options below.
          </span>
        </div>
        <i :class="show_details ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="text-warning"></i>
      </div>
    </div>
<div class="row g-3 mt-1">
    <!-- Voucher Code -->
    <div class="col-md-8 col-lg-6 mx-auto text-start">
      <div class="card-tabular mb-3">
        <div class="card-header" style="background-color: #684e72; color: white;">
          <i class="fa fa-ticket-alt me-2"></i> Enter voucher code
        </div>
        <div class="card-body _wildSand py-3 px-3 text-start">
          <p class="text-muted small mb-2 text-start">Have a voucher? Enter it below to earn free days.</p>
          <div class="d-flex gap-2">
            <el-input v-model="voucher" placeholder="Voucher code" style="flex: 1;" />
            <el-button type="warning">Send</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Invite Friends -->
    <div class="col-md-8 col-lg-6 mx-auto text-start">
      <div class="card-tabular mb-3">
        <div class="card-header" style="background-color: #f1a6ab; color: white;">
          <i class="fa fa-user-plus me-2"></i> Invite your friends
        </div>
        <div class="card-body _wildSand py-3 px-3 text-start">
          <p class="text-muted small mb-2 text-start">Invite a friend by email and earn bonus days when they join.</p>
          <div class="d-flex gap-2">
            <el-input v-model="friend_email" placeholder="Friend's email address" style="flex: 1;" />
            <el-button type="warning">Send</el-button>
          </div>
        </div>
      </div>
    </div>
</div>
<div class="row g-3 mt-1">
    <!-- Collapsible Info Section -->
    <div class="col-md-8 col-lg-6 mx-auto" v-show="show_details">
      <div class="card-tabular mb-3">
        <div class="card-header text-start" style="background-color: #3a3a3a; color: white;">
          <i class="fa fa-gift me-2"></i> Earn more free usage!
        </div>
        <div class="card-body _wildSand py-3 px-3 text-start">
          <p class="text-muted mb-3 text-start" style="line-height: 1.6;">
            You can earn more free usage by entering a voucher code, inviting friends via email, or sharing about us on social media.
            Free usage is capped at <strong>180 days max</strong>.
          </p>

          <div class="mb-3 text-start">
            <div class="fw-semibold mb-1 text-start"><i class="fa fa-ticket-alt me-1 text-secondary"></i> Voucher code</div>
            <p class="text-muted small mb-0 text-start">
              A successful voucher code entry gives you extra free days depending on the code. Keep an eye on your notifications.
            </p>
          </div>

          <div class="text-start">
            <div class="fw-semibold mb-2 text-start"><i class="fa fa-users me-1 text-secondary"></i> Email referral rewards</div>
            <ul class="list-unstyled mb-0 ps-0 text-start">
              <li class="d-flex align-items-center mb-1 text-start">
                <span class="badge bg-warning text-dark me-2">1st</span> invite → <strong class="ms-1">15 free days</strong>
              </li>
              <li class="d-flex align-items-center mb-1 text-start">
                <span class="badge bg-warning text-dark me-2">2nd</span> invite → <strong class="ms-1">30 free days</strong>
              </li>
              <li class="d-flex align-items-center text-start">
                <span class="badge bg-warning text-dark me-2">3rd</span> invite → <strong class="ms-1">45 free days</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    </div>
</div>
  </div>
</template>

<script>

export default {
  name: "Voucher",
  data() {
    return {
      loadingInstance: null,
      voucher: "",
      friend_email: "",
      show_details: false,
    };
  },
 methods: {
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
        fullscreen: true
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    toggleInformation() {
      this.show_details = !this.show_details;
    },
  },
};
</script>

<style scoped>
.subscription-list li {
  list-style: disc;
}
</style>